import { DecodedTrackerPositionMessage, MobilePositionMessage } from '../interfaces';

export type PositionDto = DecodedTrackerPositionMessage | MobilePositionMessage;

export type ExternalIdSource = 'vehicles' | 'drivers' | 'semitrailers';

export type MobileApplicationType = 'driver_app' | 'stork_supervisor_app' | 'stork_driver_app';

export type TrackerType = 'calamp' | 'teltonika' | 'queclink';
